import { CollectionInterface } from '../../../interfaces/collection.interface';

export class PickCollection {
    public static readonly type = '[JobsPlacements] Pick a collection';

    constructor(public collection: CollectionInterface | null) { }
}
